module.exports = __webpack_public_path__ + "img/next-icon-white.39102f05.svg";